<template>
  <div class="profiles-filters">
    <div class="profiles-filters__wrapper">
      <div class="form-group profiles-filters__positions">
        <c-input
          v-model="filters.positions"
          type="select"
          :multiple="true"
          :items="positions"
          :searchable="true"
          label="Должность"
          placeholder="Все"
          :checkbox-value="filters.positionsExclude"
          :checkbox="true"
          :checkbox-type="'icon'"
          :checkbox-tooltip="excludeCheckboxTooltip"
          @checkboxChange="filters.positionsExclude = $event"
        />
      </div>

      <div class="form-group profiles-filters__name">
        <c-input v-model="filters.name" :clearable="true" label="Наименование" placeholder="Любое" @enter="!$event && apply()" />
      </div>

      <div class="form-group profiles-filters__actions">
        <div class="actions-wrapper">
          <c-button class="profiles-filters__reset" label="Сбросить" @click="reset" />
          <c-button class="profiles-filters__apply" label="Применить" :color="'primary'" @click="apply" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";

import { EXCLUDE_CHECKBOX_TOOLTIP } from "@/constants/excludeCheckboxTooltip";

export default {
  components: { CButton, CInput },

  props: ["filters"],

  data() {
    return {
      excludeCheckboxTooltip: EXCLUDE_CHECKBOX_TOOLTIP,
    };
  },

  computed: {
    positions() {
      return this.$store.state.positions.positionsList;
    },
  },

  methods: {
    apply() {
      this.$emit("apply");
    },
    reset() {
      this.filters.positions = [];
      this.filters.positionsExclude = false;
      this.filters.name = "";
      this.apply();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.profiles-filters {
  padding-bottom: 6px;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
  }
  .form-group {
    padding-left: 10px;
    padding-right: 10px;
  }
  &__positions {
    flex-shrink: 1;
    flex-basis: 100%;
  }
  &__name {
    flex-basis: 100%;
    flex-shrink: 1;
  }
  &__actions {
    flex-shrink: 0;
    flex-basis: 100%;
  }
  .actions-wrapper {
    display: flex;
    margin-left: -5px;
    margin-right: -5px;
  }
  &__reset,
  &__apply {
    margin: 0 5px;
  }

  @include beforeBootstrapMd {
    &__reset,
    &__apply {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 50%;
    }
  }

  @include bootstrapMd {
    &__name {
      flex-basis: 50%;
    }

    &__actions {
      flex-basis: 50%;
    }
    .actions-wrapper {
      justify-content: flex-end;
    }
  }

  @include bootstrapXl {
    &__wrapper {
      flex-wrap: nowrap;
    }
    &__actions {
      justify-content: flex-start;
      flex-basis: 25%;
    }
  }
}
</style>
